import {
	IExtremeSetData,
	IExtremeSetNames,
	ITemplateDataPayload,
	ITemplateFormData,
} from 'modules/admin-panel/pages/templates/models';

export const extremesMapping = (set: IExtremeSetData) => {
	return (Object.keys(set) as Array<keyof IExtremeSetNames>).reduce(
		// @ts-ignore
		(res: Record<IExtremeSetNames, string>, name: IExtremeSetNames | 'id') => {
			if (name === 'id') {
				return {
					...res,
					id: set[name],
				};
			}
			return {
				...res,
				[name]: set[name].text,
			};
		},
		{},
	);
};

export function mapTemplateDataPayload(
	data: ITemplateFormData,
): ITemplateDataPayload {
	return {
		...data,
		// @ts-ignore
		workStyleSlidersExtremes: !data.isQuick
			? data.workStyleSlidersExtremes?.map(extremesMapping)
			: undefined,
		// @ts-ignore
		performanceSlidersExtremes: !data.isQuick
			? data.performanceSlidersExtremes?.map(extremesMapping)
			: undefined,
		questions: data.questions.map(({ text, id }) => ({ question: text, id })),
	};
}
